import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

export interface InvoiceNotesChangeEvent {
  invoice_header: string
  notes: string
  paymentTerms: string
  paymentInstructions: string
}

@Component({
  selector: 'app-invoice-notes',
  templateUrl: './invoice-notes.component.html',
  styleUrls: ['./invoice-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InvoiceNotesComponent implements OnInit, OnDestroy, OnChanges {
  @Input() editable = true
  @Input() paymentTerms: string
  @Input() paymentInstructions: string
  @Input() notes: string
  @Input() invoiceHeader: string

  @Input() rootForm: UntypedFormGroup
  form = this.fb.group({
    invoice_header: [],
    notes: [],
    paymentTerms: [],
    paymentInstructions: [],
  })

  @Output() update = new EventEmitter<InvoiceNotesChangeEvent>()

  destroy$ = new Subject<boolean>()

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit() {
    this.form.patchValue({
      invoice_header: this.invoiceHeader,
      notes: this.notes,
      paymentTerms: this.paymentTerms,
      paymentInstructions: this.paymentInstructions,
    })

    this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.update.emit(this.form.getRawValue() as InvoiceNotesChangeEvent)
    })
    this.rootForm.addControl('notes', this.form)
  }

  ngOnChanges(changes: SimpleChanges): void {
    const editableChange = changes['editable']
    if (editableChange) {
      editableChange.currentValue ? this.form.enable() : this.form.disable()
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
